var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 8,
    viewBox: "0 0 21 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 4",
    d: "M19.8954 4.29105C20.0907 4.09579 20.0907 3.77921 19.8954 3.58395L16.7135 0.401966C16.5182 0.206704 16.2016 0.206704 16.0064 0.401966C15.8111 0.597228 15.8111 0.913811 16.0064 1.10907L18.8348 3.9375L16.0064 6.76593C15.8111 6.96119 15.8111 7.27777 16.0064 7.47303C16.2016 7.6683 16.5182 7.6683 16.7135 7.47303L19.8954 4.29105ZM0.492188 4.4375H19.5419V3.4375H0.492188V4.4375Z",
    fill: "#5EEECD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowDark);
export default __webpack_public_path__ + "static/media/right-arrow-dark.feaf680b7c27bbe5f2c104c806c5eaa4.svg";
export { ForwardRef as ReactComponent };